import React, { useState, useEffect } from "react";
import "./index.css";
import AgentLogin from "./AgentLogin";
import Clients from "./views/Clients";
import Settings from "./views/Settings";
import Tags from "./views/Tags";
import MTDAuths from "./views/MTDAuths";
import { Route, BrowserRouter as Router, withRouter } from "react-router-dom";
import HttpsRedirect from "react-https-redirect";
import { ProtectedRoutes } from "./protected.routes";
import MixPanelScreenChange from "./routelistener.js";
import { advisorAtom } from "./atom.js";
import { useRecoilState } from "recoil";
import LoginPopup from "./components/LoginPopup";

// global.api_url = "api.untied.io";
global.api_url = "untied1.eu.ngrok.io";
if (process.env.NODE_ENV !== "development") {
  global.api_url = "api.untied.io";
}

global.partner_id = "775dbaef-6ac1-49a1-bfea-9ce82b8dbd2a";

//heartbeat intervals 
const pingInterval = 1800
const pingTimeoutThreshold = 2700
// const pingTimeoutThreshold = 200

const Routes = (props) => {
  const [showTimeout, setShowTimeout] = useState(false);
  const [advisor, ] = useRecoilState(advisorAtom)


  const LoginTimeout = 7200000 //120 mins
  // const LoginTimeout = 720000 //12 mins
  // const LoginTimeout = 72000 //120 seconds
  // const LoginTimeout = 7200 //12 seconds

  /*
    Heartbeat function. Used to check if app has been running and allows us to force a log out when restarted and
    the app/browser was previously closed. When heartbeat starts again we check if more than pingTimeoutThreshold
    seconds has elapsed since last beat, and if so force a log out. Heartbeat runs every pingThreshold seconds.
  */

  useEffect(() => {
    localStorage.setItem("pingTime", new Date())

    setInterval(()=> {
      const token = localStorage.getItem("agentToken");
      const lastEvent = localStorage.getItem("pingTime")
      
      if (token && lastEvent && lastEvent!=="") {
        //how many seconds elapsed from now 
        const nowTime = new Date();
        const thenTime = Date.parse(lastEvent);

        const dif = nowTime - thenTime;
        const secondsElapsed = dif/1000;
        
      
        if (secondsElapsed>pingTimeoutThreshold) {
          
          //browser must have been closed ... clear localStorage and force a re-render - this will log us out
          localStorage.removeItem("agentToken");
          setShowTimeout(true);
          // localStorage.clear()
        }
      }
     
      localStorage.setItem("pingTime", new Date())
      
    },pingInterval*100)
  },[])

  const startTimer = () => {
    setTimeout(() => {
      const token = localStorage.getItem("agentToken");
      if (token) {
        //remove the token
        localStorage.removeItem("agentToken");
        setShowTimeout(true);
      }
    }, LoginTimeout );

  };

  useEffect(() => {
    const token = localStorage.getItem("agentToken");
    if (token) {      
      startTimer();
    }
  }, [advisor]);

  const isloggedIn = () => {
    
    return localStorage.getItem("agentToken")
  };

  if (showTimeout) {
    return (
      <LoginPopup
        routerProps={props}
        setShowTimeout={setShowTimeout}
        startTimer={startTimer}
      />
    );
  }

  return (
    <HttpsRedirect>
        <Router>
          <div>
            <Route exact path="/login" component={AgentLogin} />
            <Route exact path="/logout" component={AgentLogin} />
            <Route path="/logout/:logout" component={AgentLogin} />

            <Route path="/magiclink/:token/:email" component={AgentLogin} />

            <Route
              exact
              path="/"
              render={(routerProps) =>
                isloggedIn() ? (
                  routerProps.history.push("/clients" + (routerProps.location.search || ""))
                ) : (
                  routerProps.history.push("/logout")
                )
              }
            />

            <ProtectedRoutes exact path="/clients" component={Clients} />
            <ProtectedRoutes exact path="/settings" component={Settings} />
            <ProtectedRoutes exact path="/tags" component={Tags} />
            <ProtectedRoutes exact path="/mtdauths" component={MTDAuths} />

          </div> 
          <MixPanelScreenChange />
        </Router>
     </HttpsRedirect>
  );
};

export default withRouter(Routes);
